module.exports = __webpack_public_path__ + "img/DS_40_4x6.e8cd6bdd.jpg";